import makeSlice from '@web/slices/abTest/sliceMaker'

const slice = makeSlice()

export default slice.reducer
